<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-6"></a>
<p class="fm-head1">Abbreviations</p>
<table class="table">
<tbody><tr>
<td class="td"><p class="nonindent">PCCRP</p></td>
<td class="td"><p class="nonindent">Prerogative Court of Canterbury and Related Probate Jurisdictions</p></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005_About_the_author.vue?a9b2d6e2